"use client";

import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils/cn";

type ChoiceProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;
const choiceClass =
  "h-4 w-4 shrink-0 border-border bg-surface-primary text-accent accent-[var(--accent-primary)] transition-colors duration-fast focus-visible:ring-2 focus-visible:ring-accent/25 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-status-error/25";

export const Checkbox = forwardRef<HTMLInputElement, ChoiceProps>(function Checkbox({ className, ...props }, ref) {
  return <input ref={ref} type="checkbox" className={cn(choiceClass, "rounded-xs", className)} {...props} />;
});

export const Radio = forwardRef<HTMLInputElement, ChoiceProps>(function Radio({ className, ...props }, ref) {
  return <input ref={ref} type="radio" className={cn(choiceClass, "rounded-full", className)} {...props} />;
});

export type SwitchProps = ChoiceProps;

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch({ className, ...props }, ref) {
  return (
    <label className={cn("relative inline-flex h-6 w-11 shrink-0 items-center", props.disabled && "cursor-not-allowed opacity-50", className)}>
      <input ref={ref} type="checkbox" role="switch" className="peer sr-only" {...props} />
      <span className="absolute inset-0 rounded-full border border-border bg-surface-inset transition-colors duration-base peer-checked:border-accent peer-checked:bg-accent peer-focus-visible:ring-2 peer-focus-visible:ring-accent/25 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-surface-primary peer-aria-[invalid=true]:border-status-error" />
      <span className="pointer-events-none absolute left-1 h-4 w-4 rounded-full bg-surface-primary shadow-raised transition-transform duration-base peer-checked:translate-x-5" />
    </label>
  );
});
